import type { VehicleCoverages } from 'api/quote-marketplace';
import { PROVINCE_ONTARIO } from 'variables/constants';

export const applyRideSharingDefaults = (
  coverages: VehicleCoverages,
  provinceCode: number,
  enabled: boolean,
): VehicleCoverages => {
  if (!enabled) {
    return {
      ...coverages,
      ride_sharing_enabled: false,
      opcf_6a_passengers_enabled: false,
      opcf_6a_described_use: '',
      ...(provinceCode === PROVINCE_ONTARIO && { opcf_4_min_enabled: false }),
    };
  }

  return {
    ...coverages,
    ride_sharing_enabled: true,
    opcf_6a_passengers_enabled: true,
    ...(provinceCode === PROVINCE_ONTARIO && { opcf_4_min_enabled: true }),
  };
};
